import TYPES from '@/store/types'

const getters = {
}

export default getters
